/* -------------------------------------------------- */
/*  src/media/media.js                                 */
/*  Full-screen Sketchfab embed wrapper               */
/* -------------------------------------------------- */
import React from "react";

export default function Media() {
  return (
    <div style={{
      position: "relative",
      width: "100vw",
      height: "100vh",
      overflow: "hidden"
    }}>
      {/* Inject fullscreen embed styles */}
      <style>{`
        .sketchfab-embed-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          pointer-events: auto;
          z-index: 0;
        }
        .sketchfab-embed-wrapper > iframe {
          width: 120%;
          height: 120%;
          transform: translate(-10%, -10%) scale(1.1);
          border: none;
          pointer-events: auto;
        }
      `}</style>

      {/* Fullscreen Sketchfab embed */}
      <div className="sketchfab-embed-wrapper">
        <iframe
          title="Broadcast Live News Studio | Baked"
          frameBorder="0"
          allowFullScreen
          mozAllowFullScreen="true"
          webkitAllowFullScreen="true"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          src="https://sketchfab.com/models/145a70d8b7b9462082a2de64d3b34109/embed?autostart=1"
        />
      </div>
    </div>
  );
}
